
export default function Requirements() {
  return (
    <section id="requisitos" className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Recomendaciones para obtener el visado
            </h2>
            <p className="text-xl text-gray-700">
              Algunos documentos necesarios para iniciar tu solicitud
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 mb-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-8">✔ Condiciones generales</h3>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4 pb-6 border-b border-gray-200">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                  <i className="ri-passport-fill text-2xl text-blue-600"></i>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg font-bold text-gray-900 mb-2">Ciudadanía y documentación básica</h4>
                  <p className="text-gray-600">Ser ciudadano no perteneciente a la Unión Europea. Presentar pasaporte completo y formulario oficial de solicitud.</p>
                </div>
              </div>

              <div className="flex items-start gap-4 pb-6 border-b border-gray-200">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                  <i className="ri-shield-check-fill text-2xl text-blue-600"></i>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg font-bold text-gray-900 mb-2">Antecedentes penales</h4>
                  <p className="text-gray-600">Certificado de antecedentes penales legalizado de los últimos dos años.</p>
                </div>
              </div>

              <div className="flex items-start gap-4 pb-6 border-b border-gray-200">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                  <i className="ri-money-dollar-circle-fill text-2xl text-blue-600"></i>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg font-bold text-gray-900 mb-2">Solvencia económica</h4>
                  <p className="text-gray-600">Demostrar mínimo 200% del SMI, aproximadamente <strong>33.151,92 €</strong>.</p>
                </div>
              </div>

              <div className="flex items-start gap-4 pb-6 border-b border-gray-200">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                  <i className="ri-bank-card-fill text-2xl text-blue-600"></i>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg font-bold text-gray-900 mb-2">Tasa administrativa</h4>
                  <p className="text-gray-600">Pagar la tasa administrativa indicada.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                  <i className="ri-graduation-cap-fill text-2xl text-blue-600"></i>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg font-bold text-gray-900 mb-2">Formación o experiencia</h4>
                  <p className="text-gray-600">Presentar título universitario o experiencia comprobada.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl shadow-xl p-8 text-white">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mb-6">
                <i className="ri-building-fill text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Si trabajas para una empresa extranjera</h3>
              <ul className="space-y-3 text-lg">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl mt-1 flex-shrink-0"></i>
                  <span>Relación laboral continua de al menos 3 meses</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl mt-1 flex-shrink-0"></i>
                  <span>Empresa con 1 año mínimo de actividad previa</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl mt-1 flex-shrink-0"></i>
                  <span>Autorización formal para teletrabajar desde España</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl mt-1 flex-shrink-0"></i>
                  <span>Contrato y últimas nóminas</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl mt-1 flex-shrink-0"></i>
                  <span>Otros</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-green-600 to-green-700 rounded-2xl shadow-xl p-8 text-white">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-full mb-6">
                <i className="ri-user-star-fill text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Si trabajas como autónomo o freelance</h3>
              <ul className="space-y-3 text-lg">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl mt-1 flex-shrink-0"></i>
                  <span>Al menos un cliente extranjero (empresa)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl mt-1 flex-shrink-0"></i>
                  <span>Relación profesional mínima de 3 meses</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-xl mt-1 flex-shrink-0"></i>
                  <span>Otros</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-gradient-to-r from-yellow-100 to-orange-100 border-4 border-yellow-500 rounded-2xl p-8 mb-8 shadow-2xl max-w-3xl mx-auto">
              <div className="flex items-start gap-4">
                <div className="w-16 h-16 flex items-center justify-center bg-yellow-500 rounded-full flex-shrink-0">
                  <i className="ri-alert-fill text-white text-3xl"></i>
                </div>
                <div className="text-left flex-1">
                  <h4 className="text-2xl font-bold text-gray-900 mb-3">⚠️ Importante</h4>
                  <p className="text-xl text-gray-800 leading-relaxed">
                    Cualquier error en la documentación puede derivar en <strong className="text-red-700">retrasos o rechazos</strong>. Te acompañamos en cada paso para <strong className="text-green-700">garantizar el éxito</strong>.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap justify-center gap-4">
              <a 
                href="#consulta" 
                className="bg-blue-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Solicitar Asesoría
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
